import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
const HeaderModal = ({ title, subtitle, success = false, warning = false }) => {
  return (
    <Modal.Header
      closeButton
      className="jobs-modal-header"
      style={{
        padding: '1rem 2rem 0',
        backgroundColor: 'white',
        color: 'black',
        border: 'none'
      }}>
      <Modal.Title
        id="contained-modal-title-vcenter"
        className="d-flex flex-column text-center mx-auto"
        style={{ display: 'flex', flexDirection: 'column', fontSize: '24px' }}>
        <FontAwesomeIcon
          className="mb-4"
          icon={success ? faCircleCheck : warning ? faCircleExclamation : null}
          style={{ fontSize: '35px' }}
        />
        <h3 className="title-modal-st my-0" style={{ fontSize: '24px', fontWeight: '700' }}>
          {title}
        </h3>
        <p className="subtitle-modal-st my-0" style={{ fontSize: '18px', fontWeight: '700' }}>
          {' '}
          {subtitle}
        </p>
      </Modal.Title>
    </Modal.Header>
  );
};

export default HeaderModal;
